import SaveMoreVehicleCardDetails from "@modules/vehicle/types/saveMoreVehicleCardDetails";
import { SavedNoHeart, SavedOneHeart, SavedTwoHeart } from "@public/images";
import { i18n } from "next-i18next";
import { UserFavouriteVehicle } from "../types/UserFavouriteVehicle";

type Prop = {
  isLoggedIn: boolean | undefined;
  favouriteVehiclesCopy: UserFavouriteVehicle[] | undefined;
  navigateToVlp: () => void;
  handleLoginClicked: () => void;
};

const getSaveMoreCardHeading = (
  userFavouriteVehicles: UserFavouriteVehicle[] | undefined
): string => {
  let heading = "";
  switch (userFavouriteVehicles?.length || 0) {
    case 3:
      heading =
        i18n?.t("staticPromoCards:save_more_card_heading_zero_remaining") || "";
      break;

    case 2:
      heading =
        i18n?.t("staticPromoCards:save_more_card_heading_one_remaining") || "";
      break;

    case 1:
      heading =
        i18n?.t("staticPromoCards:save_more_card_heading_two_remaining") || "";
      break;
    default:
      return heading;
  }
  return heading;
};

const getSaveMoreVehicleCardDetails = ({
  isLoggedIn,
  favouriteVehiclesCopy,
  navigateToVlp,
  handleLoginClicked,
}: Prop) => {
  let cardDetails: SaveMoreVehicleCardDetails;

  if (isLoggedIn) {
    cardDetails = {
      backgroundImage: {
        src: SavedNoHeart,
        altText: "",
        ellipseColour: "bg-primary-light",
      },
      cardButton: {
        title: i18n?.t("staticPromoCards:shop_inventory") || "",
        onClick: navigateToVlp,
      },
      cardHeading:
        i18n?.t("staticPromoCards:save_more_card_heading_auth") || "",
      cardSubHeading:
        i18n?.t("staticPromoCards:save_more_card_sub_heading_auth") || "",
      cardDescription:
        i18n?.t("staticPromoCards:save_more_card_description_auth") || "",
    };
  } else {
    cardDetails = {
      backgroundImage: {
        src:
          (favouriteVehiclesCopy?.length || 0) === 1
            ? SavedTwoHeart
            : SavedOneHeart,
        altText: "",
        ellipseColour: "bg-secondary-salmon-100",
      },
      cardButton: {
        title: i18n?.t("staticPromoCards:get_started") || "",
        onClick: handleLoginClicked,
      },
      cardHeading: getSaveMoreCardHeading(favouriteVehiclesCopy),
      cardSubHeading:
        i18n?.t("staticPromoCards:save_more_card_sub_heading_no_auth") || "",
      cardDescription:
        i18n?.t("staticPromoCards:save_more_card_description_no_auth") || "",
    };
  }

  return cardDetails;
};

export default getSaveMoreVehicleCardDetails;
